import { render, staticRenderFns } from "./PortalTargetSitecore.vue?vue&type=template&id=65e52316"
import script from "./PortalTargetSitecore.vue?vue&type=script&lang=js"
export * from "./PortalTargetSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports